import React from 'react';
import './Layout.css';
import NewTopBar from './NewTopBar';

interface LayoutProps {
  map: React.ReactNode;
  sidebar: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ map, sidebar }) => {

  return (
    <div className="layout">
      <NewTopBar />
      
      <div className="main-content">
        {/* Map Section */}
        <div className="map-area">
          {map}
        </div>
        
        {/* Sidebar */}
        <div className="sidebar">
          {sidebar}
        </div>
      </div>
    </div>
  );
};

export default Layout;
